import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import { Box, Button, Grid, Stack, Typography } from '@mui/material';
import {
  CheckCircleOutline as CheckCircleOutlineIcon,
  EventAvailable as EventAvailableIcon,
  FilterListOutlined as FilterListOutlinedIcon,
  ImportantDevices as ImportantDevicesIcon,
  MyLocation as MyLocationIcon,
} from '@mui/icons-material';
import {
  BasicColumnGraphV2,
  CustomFilterV2,
  WidgetDescriptionV2,
  WidgetV2,
} from '../../../components/v2';
import * as selectorsDashboard from '../../../store/dashboard/reducer';
import * as dashboardActions from '../../../store/dashboard/actions';

const iconSx = { height: 32, width: 32 };

const defaultFilter = {
  status: [],
  dateTypes: [],
  tipoServicos: [],
  inicio: moment().subtract(1, 'year').startOf('year').valueOf(),
  fim: moment().endOf('day').valueOf(),
};

const DashboardV2 = ({ loadDashboard, dashboardData }) => {
  const [openFilter, setOpenFilter] = useState(false);
  const [localFilter, setLocalFilter] = useState(defaultFilter);

  useEffect(() => {
    loadDashboard(defaultFilter);
  }, [loadDashboard]);

  return (
    <Box sx={{ p: 3 }}>
      <Stack spacing={3}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          justifyContent="space-between"
          alignItems={{ xs: 'flex-start', md: 'center' }}
          spacing={2}
          sx={{ pr: 2 }}
        >
          <Typography variant="h4">Dashboard</Typography>
          <Button
            variant="outlined"
            startIcon={<FilterListOutlinedIcon />}
            onClick={() => setOpenFilter(true)}
          >
            Filtros
          </Button>
        </Stack>

        <Grid container spacing={3}>
          <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
            <WidgetDescriptionV2
              title="NSIR CONCLUÍDAS"
              description={String(dashboardData?.executadasGdis ?? 0)}
              icon={<CheckCircleOutlineIcon sx={iconSx} />}
              avatarStyle={{ backgroundColor: 'green' }}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
            <WidgetDescriptionV2
              title="NSIR EM INSPEÇÃO"
              description={String(dashboardData?.emInspecao ?? 0)}
              icon={<MyLocationIcon sx={iconSx} />}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
            <WidgetDescriptionV2
              title="NSIR EM DIGITAÇÃO"
              description={String(dashboardData?.emDigitacao ?? 0)}
              icon={<ImportantDevicesIcon sx={iconSx} />}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
            <WidgetDescriptionV2
              title="NSIR EM ATRASO"
              description={String(dashboardData?.emAtraso ?? 0)}
              icon={<EventAvailableIcon sx={iconSx} />}
              avatarStyle={{ backgroundColor: '#f44336' }}
            />
          </Grid>
          <Grid size={{ xs: 12 }}>
            <WidgetV2 title="Nsir a Vencer">
              <BasicColumnGraphV2
                seriesData={dashboardData?.graph ?? null}
                yAxisTitle="N° de Nsir a Vencer"
              />
            </WidgetV2>
          </Grid>
        </Grid>

        <CustomFilterV2
          variant="dialog"
          open={openFilter}
          onClose={() => setOpenFilter(false)}
          title="Filtros"
          fullWidth
          defaultFilter={defaultFilter}
          appliedFilter={localFilter}
          fields={[
            { field: 'useDates', md: 2, xs: 6 },
            { field: 'useCodigo', codigoLabel: 'Nsir', md: 2, xs: 6 },
            { field: 'useMalha', md: 3, xs: 12 },
            { field: 'useGerencia', md: 3, xs: 12 },
            { field: 'usePolo', md: 3, xs: 12 },
            { field: 'useSubestacao', md: 3, xs: 12 },
            { field: 'useAlimentador', md: 3, xs: 12 },
            { field: 'useNsirStatus', multiSelect: true, md: 12, xs: 12 },
          ]}
          onFilter={(filterData) => {
            setLocalFilter(filterData);
            loadDashboard(filterData);
            setOpenFilter(false);
          }}
        />
      </Stack>
    </Box>
  );
};

const mapStateToProps = (state) => ({
  dashboardData: selectorsDashboard.getDashboardData(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators({ ...dashboardActions }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(DashboardV2);
